import * as types from './types';
import api from '@/api/graphql/account';

export default {
  state: {
    account: {},
  },
  getters: {
    [types.ACCOUNT]: state => state.account,
  },
  mutations: {
    [types.ACCOUNT]: (state, payload) => {
      state.account = payload.account;
    },
    [types.SIGN_IN]: (state, payload) => {
      state.account.signIn = 1;
      state.account.force += payload.force;
    },
  },
  actions: {
    [types.FETCH_ACCOUNT]: ({ commit }) => {
      api.getAccount()
        .then(({ account }) => {
          commit(types.ACCOUNT, {
            account,
          });
        });
    },
    [types.SIGN_IN]: ({ commit }) => {
      api.signIn()
        .then(({ signIn }) => {
          commit(types.SIGN_IN, {
            force: signIn.force,
          });
        });
    },
  },
};
